import { render, staticRenderFns } from "./CSVersion.vue?vue&type=template&id=5aa835d1&scoped=true&"
import script from "./CSVersion.vue?vue&type=script&lang=js&"
export * from "./CSVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa835d1",
  null
  
)

export default component.exports